import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8" data-id="element-110">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-dark-surface to-dark-bg p-8 md:p-12 rounded-2xl border border-brand-orange/20 shadow-2xl relative overflow-hidden" data-id="element-111">
        <div className="absolute -right-10 -top-10 text-brand-orange/5" data-id="element-112">
          <ShieldCheck className="w-64 h-64" data-id="element-113" />
        </div>

        <div className="relative z-10" data-id="element-114">
          <h2 className="font-oswald text-3xl md:text-4xl font-bold mb-6 uppercase text-brand-orange" data-id="element-115">
            Resultados Reales en Tiempo Récord
          </h2>
          <p className="font-inter text-xl md:text-2xl text-gray-200 leading-relaxed font-medium italic" data-id="element-116">
            "En solo 7 días, la mayoría de los hombres reportan una caída
            drástica en la inflamación de la cara, mejor calidad de sueño y la
            desaparición total del 'sueño de las 3 de la tarde'. No estás
            bajando solo peso, estás recuperando tu metabolismo original."
          </p>
        </div>
      </div>
    </section>;
}